import ReactVisibilitySensor from "react-visibility-sensor";
import Counter from "../Counter/Counter";
import { useContext } from "react";
import { LangContext } from "../../App";

type TableBorderLeftProps = {
    items : Items[]
};

type Items = {
    number? : {
        value? : number;
        unit? : string;
    };
    label? : string | JSX.Element;
    numberTwo? : {
        value? : number;
        unit? : string;
        sup? : string;
    } | null;
    icon? : {
        src : string;
        alt : string;
    };
    subtitle? : JSX.Element | string | undefined;
    subtitleTwo? : JSX.Element | string | undefined;
}

const TableBorderLeft = ({ items } : TableBorderLeftProps) => {
    const { lang } = useContext(LangContext);

  return (
    <div className={`table-border-left ${lang ? "rtl" : ""}`}>
        {items.map((item, index) => (
            <ReactVisibilitySensor
                partialVisibility
            >
            {({isVisible} : any) => (
            <div className={`table-column ${isVisible ? "visible" : ""}`}>
                {item.icon ? 
                <img 
                    src={item.icon.src} 
                    alt={item.icon.alt} 
                    className={`table-icon an-pop-up ${isVisible ? "an-active" : ""}`} 
                    aria-hidden={true} 
                /> 
                : ""}
                {item.label ? 
                <p className={`table-subtitle an-move-left-fade-in ${isVisible ? "an-active" : ""}`}>{item.label}</p> :
                ""}
                {item.number ?
                    <h3 className="table-number">
                        {item.number.value ?
                        <Counter 
                            counterValue={item.number.value} 
                            applyCounteClassName={"table-number-value"}
                        />
                        : ""}
                        <span className="table-number-unit">{item.number.unit}</span>
                    </h3>
                : ""}
                {item.subtitle ? 
                <p className={`table-subtitle an-move-left-fade-in ${isVisible ? "an-active" : ""}`}>{item.subtitle}</p> 
                : ""}
                {item.numberTwo ?
                    <h3 className="table-number">
                        {
                        item.numberTwo.value ?
                        <Counter 
                            counterValue={item.numberTwo.value} 
                            applyCounteClassName={"table-number-value"}
                        /> :
                        ""
                        }
                        <span className="table-number-unit">{item.numberTwo.unit}</span>
                        {item.numberTwo.sup ? <sup>3</sup> : ''}
                    </h3>
                : ""}
                {item.subtitleTwo ? 
                <p className={`table-subtitle an-move-left-fade-in ${isVisible ? "an-active" : ""}`}>{item.subtitleTwo}</p> 
                : ""}
            </div>
            )}
            </ReactVisibilitySensor>
        ))}
    </div>
  )
}

export default TableBorderLeft